import * as React from 'react';
import { ModalProps as BSModalProps } from 'react-bootstrap';

import Modal, {
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter,
} from '../../react-common/Modal';
import HistoryTable, { HistoryTableProps } from '../HistoryTable/HistoryTable';

export const HistoryModal: React.FunctionComponent<
  HistoryTableProps & BSModalProps
> = ({ show, onHide, type, id }) => (
  <Modal show={show} onHide={onHide} bsSize="large">
    <ModalHeader>
      <ModalTitle style={{ textAlign: 'center' }}>History</ModalTitle>
    </ModalHeader>
    <ModalBody>
      <HistoryTable type={type} id={id} />
    </ModalBody>
    <ModalFooter />
  </Modal>
);

type HistoryModalButtonProps = {
  value?: string | JSX.Element;
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  key: string | number;
};

export const HistoryModalButton: React.FunctionComponent<
  HistoryTableProps & HistoryModalButtonProps & BSModalProps
> = ({ onClick, value, type, id, show, onHide, disabled }) => (
  <>
    <button className="btn btn-default" onClick={onClick} disabled={disabled}>
      {value || 'View History'}
    </button>
    <HistoryModal type={type} id={id} show={show} onHide={onHide} />
  </>
);
